module.exports = __webpack_public_path__ + "img/img_goal_round1.ef3ed2dd.png";